module.exports = __webpack_public_path__ + "static/media/icon_62.79751f48.svg";